import { createReducer, on } from "@ngrx/store";
import { CreateTeamTeachersResponse } from "src/app/shared/interfaces/orgadmin/course-teachers";
import { RequestStatus } from "src/app/shared/interfaces/request-status";
import {
  editTeamTeachers,
  editTeamTeachersFail,
  editTeamTeachersLoad,
  editTeamTeachersSuccess,
} from "../../actions/admin/edit-team-teachers.actions";

export interface EditTeamTeachersState {
  status: RequestStatus;
  error: CreateTeamTeachersResponse | null;
}

const initialState: EditTeamTeachersState = {
  status: "IDLE",
  error: null,
};

export const editTeamTeachersReducer = createReducer(
  initialState,

  on(
    editTeamTeachersLoad,
    (state): EditTeamTeachersState => ({
      ...state,
      status: "PENDING",
      error: null,
    }),
  ),
  on(
    editTeamTeachersSuccess,
    (state): EditTeamTeachersState => ({
      ...state,
      status: "SUCCESS",
      error: null,
    }),
  ),
  on(
    editTeamTeachers,
    (state): EditTeamTeachersState => ({
      ...state,
      status: "PENDING",
      error: null,
    }),
  ),
  on(
    editTeamTeachersFail,
    (state, { error }): EditTeamTeachersState => ({
      ...state,
      status: "FAILED",
      error,
    }),
  ),
);
